import { ReactNode } from 'react';
import { cn } from '~/utils/classnames';
import { posthogEvent } from '~hooks/product_analytics';

interface iCustomPosthog {
  name: string;
}

export interface iButton {
  className?: string;
  content?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  priority?: 'primary' | 'secondary' | 'tertiary' | 'close' | 'video';
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  onClick?: () => void;
  disabled?: boolean;
  posthogCustom?: iCustomPosthog;
}

function Button({
  className = '',
  content,
  type = 'button',
  priority = 'primary',
  icon = undefined,
  iconPosition = 'right',
  onClick = undefined,
  disabled = false,
  posthogCustom = undefined,
}: iButton) {
  const trackPosthogClick = () => {
    if (!posthogCustom) return;
    posthogEvent.emit({
      event: `Clicked button ${posthogCustom.name}`,
      properties: {
        button_name: posthogCustom.name,
      },
    });
  };

  return (
    <button
      disabled={disabled}
      onClick={() => {
        if (posthogCustom) trackPosthogClick();
        if (onClick) onClick();
      }}
      type={type}
      className={cn(`button button-${priority}`, className, {
        'flex-row-reverse': icon !== undefined && content !== undefined && iconPosition === 'left',
        'ph-no-capture': posthogCustom !== undefined,
      })}
    >
      {content && <span>{content}</span>}

      {icon && <span>{icon}</span>}
    </button>
  );
}

export default Button;
